module.exports = __webpack_public_path__ + "static/img/2-3.6808928.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-3.jpg
// module id = Gvnq
// module chunks = 1